import { Controller } from "@hotwired/stimulus"
import { logger } from "../utils/logger"

export default class extends Controller {
  static targets = ["link", "menu"]

  connect() {
    logger.debug('EventsDropdown controller connected')
    this.hideTimeout = null
    this.showTimeout = null
    // Ensure menu starts hidden
    if (this.hasMenuTarget && this.menuTarget) {
      this.menuTarget.classList.add("hidden")
      logger.debug('EventsDropdown menu target found and hidden')
    } else {
      logger.warn('EventsDropdown menu target not found')
    }
  }

  show() {
    logger.debug('EventsDropdown show() called')
    // Clear any pending hide timeout
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout)
      this.hideTimeout = null
      logger.debug('EventsDropdown cleared hide timeout')
    }

    // Delay showing to prevent flickering on quick mouse movements
    this.showTimeout = setTimeout(() => {
      if (this.hasMenuTarget && this.menuTarget) {
        this.menuTarget.classList.remove("hidden")
        logger.debug('EventsDropdown menu shown')
      } else {
        logger.warn('EventsDropdown cannot show menu - target not found')
      }
    }, 150) // Small delay for better UX
  }

  hide() {
    logger.debug('EventsDropdown hide() called')
    // Clear any pending show timeout
    if (this.showTimeout) {
      clearTimeout(this.showTimeout)
      this.showTimeout = null
      logger.debug('EventsDropdown cleared show timeout')
    }

    // Delay hiding to allow moving mouse to dropdown
    this.hideTimeout = setTimeout(() => {
      if (this.hasMenuTarget && this.menuTarget) {
        this.menuTarget.classList.add("hidden")
        logger.debug('EventsDropdown menu hidden')
      } else {
        logger.warn('EventsDropdown cannot hide menu - target not found')
      }
    }, 200) // Small delay to allow moving to dropdown
  }

  // Show dropdown when hovering over link
  linkMouseEnter() {
    logger.debug('EventsDropdown linkMouseEnter - hovering over EVENTS link')
    this.show()
  }

  // Hide dropdown when leaving link
  linkMouseLeave() {
    logger.debug('EventsDropdown linkMouseLeave - leaving EVENTS link')
    this.hide()
  }

  // Keep dropdown open when hovering over menu
  menuMouseEnter() {
    logger.debug('EventsDropdown menuMouseEnter - hovering over dropdown menu')
    // Clear any pending hide timeout
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout)
      this.hideTimeout = null
      logger.debug('EventsDropdown cleared hide timeout on menu hover')
    }
  }

  // Hide dropdown when leaving menu
  menuMouseLeave() {
    logger.debug('EventsDropdown menuMouseLeave - leaving dropdown menu')
    this.hide()
  }

  disconnect() {
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout)
    }
    if (this.showTimeout) {
      clearTimeout(this.showTimeout)
    }
  }
}

